import React from 'react'

export default function EmailRecipient({ color }: { color: string }) {
  return (
    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_2635_1118)">
        <path d="M18.6663 19.0026V21.7893C17.4596 21.3626 16.168 21.2317 14.9002 21.4076C13.6324 21.5835 12.4253 22.0611 11.3802 22.8002C10.3352 23.5393 9.4828 24.5183 8.89456 25.6551C8.30632 26.7919 7.99943 28.0533 7.99967 29.3333L5.33301 29.3319C5.33259 27.7038 5.7049 26.0971 6.42141 24.6351C7.13791 23.1731 8.17959 21.8945 9.46663 20.8973C10.7537 19.9001 12.2519 19.2108 13.8465 18.8821C15.4412 18.5535 17.0899 18.5955 18.6663 19.0026ZM15.9997 17.3333C11.5797 17.3333 7.99967 13.7533 7.99967 9.33325C7.99967 4.91325 11.5797 1.33325 15.9997 1.33325C20.4197 1.33325 23.9997 4.91325 23.9997 9.33325C23.9997 13.7533 20.4197 17.3333 15.9997 17.3333ZM15.9997 14.6666C18.9463 14.6666 21.333 12.2799 21.333 9.33325C21.333 6.38659 18.9463 3.99992 15.9997 3.99992C13.053 3.99992 10.6663 6.38659 10.6663 9.33325C10.6663 12.2799 13.053 14.6666 15.9997 14.6666ZM25.8903 22.6666H30.6717V25.3333H25.8903L28.329 27.7706L26.4437 29.6573L20.7863 23.9999L26.4437 18.3426L28.329 20.2293L25.8903 22.6666Z" fill={color} />
      </g>
      <defs>
        <clipPath id="clip0_2635_1118">
          <rect width="32" height="32" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}
